// A player's Audit tab (spec/13 §8 rule 5, F-ORG-14 #394): the organisation's audit log narrowed to
// one player — `targetType=player&targetId={playerId}` fixed — so a note added, a tag changed, a ban
// or a lift, every change recorded against this player, shows here. It is the same log the Audit
// screen shows, and rides the same `audit:read`; the player dialog only offers the tab to a role that holds
// it.

import { useTranslation } from '@clavian/i18n/react';
import type { ReactNode } from 'react';

import { useScopeIds } from '../../shell/scope';
import { AuditLog } from './AuditLog';

export function PlayerAuditTab({ playerId }: { readonly playerId: string }): ReactNode {
  const { t } = useTranslation('console');
  const scope = useScopeIds();
  return (
    <div className="console-people-tab">
      <p className="console-subtle">{t('players.audit.hint')}</p>
      <AuditLog organizationId={scope.organizationId} fixedTarget={{ targetType: 'player', targetId: playerId }} />
    </div>
  );
}
